import { Toggle } from '@cinesend/ui-kit'
import { useState } from 'react'

const IsExternalApiKeyField = ({ field, saveField }) => {
  const [isExternalApiKeyField, setIsExternalApiKeyField] = useState(field.is_external_api_key_field)
  return (
    <Toggle
      pressed={isExternalApiKeyField}
      text='Use as key field for External API mapping'
      onToggle={() => {
        setIsExternalApiKeyField(!isExternalApiKeyField)
        saveField({ is_external_api_key_field: !isExternalApiKeyField })
      }}
    />
  )
}

export default IsExternalApiKeyField
